var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-avatar',{staticClass:"pointer",attrs:{"src":_vm.userImg || _vm.$store.state.defaultPhoto,"size":_vm.size},nativeOn:{"click":function($event){return _vm.handleAvatarClick($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }